import { createSlice } from "@reduxjs/toolkit";

export const tourSlice = createSlice({
  name: "tour",
  initialState: {
    tourstarted: false,
    tour_name:""
  },

  reducers: {
    onTourStarter: (state,action) => {
      state.tourstarted = action?.payload;
    },
      onTourCancel: (state) => {
       state.tourstarted = false;
       

    },
    getTourname:(state,action)=>{
      state.tour_name=action.payload

    }
  },
});

export const {  onTourStarter ,onTourCancel,getTourname} = tourSlice.actions;
export default tourSlice.reducer;
